import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import styles from './PageTemplate.scss';
import classNames from 'classnames/bind';

import Header from 'components/common/Header';
import Footer from 'components/common/Footer';
import MainContentWrapper from 'components/common/PageTemplate/MainContentWrapper';

const cx = classNames.bind(styles);

@inject('commonStore','boardStore')
@observer
class PageTemplate extends Component {

	render() {
		const { sessionLoginInfo, disLogoutInfo } = this.props.commonStore;
		const { onViewMode } = this.props.boardStore;
		return (
			<div className={cx('page-template')}>
				{sessionLoginInfo !== null &&
					<Fragment>
						<Header
							sessionLoginInfo={sessionLoginInfo}
							onLogout={disLogoutInfo}
							
							onViewMode={onViewMode}
						/>
					</Fragment>
				}
				<main>
					<MainContentWrapper>
						{this.props.children}
					</MainContentWrapper>
				</main>
				<Footer/>
			</div>
		);
	}
}
export default PageTemplate;